<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NQnmc2/tc-custom/9780292748972.jpg?1726574064494" alt="This image is the cover for the book Unexamined Orwell, Literary Modernism"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unexamined Orwell, Literary Modernism
      </h1>
      <p class="bookDescription body article font2">
        <b>A reflection on Orwell-as-idea that </b><b>“outlines some of the misconceptions and misuses of the Orwell name” (<i>Modern Fiction Studies</i>).</b><br/>  <br/> The year 1984 is just a memory, but the catchwords of George Orwell’s novel <i>Nineteen Eighty-Four</i> still routinely pepper public discussions of topics ranging from government surveillance and privacy invasion to language corruption and bureaucratese. Orwell’s work pervades the cultural imagination, while others of his literary generation are long forgotten.<br/>  <br/> Exploring this astonishing afterlife has become the scholarly vocation of John Rodden, who is now the leading authority on the reception, impact, and reinvention of George Orwell—the man and writer—as well as of “Orwell” the cultural icon and historical talisman. In <i>The Unexamined Orwell</i>, Rodden delves into dimensions of Orwell’s life and legacy that have escaped the critical glare. He discusses how several leading American intellectuals have earned the title of Orwell’s “successor,” including Lionel Trilling, Dwight Macdonald, Irving Howe, Christopher Hitchens, and John Lukacs. He then turns to Germany and focuses on the role and relevance of <i>Nineteen Eighty-Four</i> in the now-defunct communist nation of East Germany. Rodden also addresses myths that have grown up around Orwell’s life, including his “more than half-legendary” encounter with Ernest Hemingway in liberated Paris in March 1945, and analyzes literary issues such as his utopian sensibility and his prose style.<br/>  <br/> Finally, Rodden poses the endlessly debated question, “What would George Orwell do?” and speculates about how the prophet of <i>Nineteen Eighty-Four</i> would have reacted to world events. In so doing, Rodden shows how our responses to this question reveal much about our culture’s ongoing need to reappropriate “Orwell.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Rodden
      </h2>
      
      <p class="authorDescription body article">JOHN RODDEN has taught at the University of Virginia and the University of Texas at Austin. He is the author or editor of Every Intellectual’s Big Brother: George Orwell’s Literary Siblings; The Politics of Literary Reputation: The Making and Claiming of St. George Orwell; Scenes from an Afterlife: The Legacy of George Orwell; Understanding Animal Farm in Historical Context; and George Orwell: Into The Twenty-First Century, among other books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67f76af6